import React from 'react';
import { Link } from 'react-router-dom';
import MenuCard from '../components/MenuCard';

const Home: React.FC = () => {
  return (
    <>
      <div className="flex flex-col gap-4 text-center mt-4">
        <h1 className="text-[32px] font-bold leading-tight tracking-tight text-white">
          Welcome, Guest
        </h1>
        <p className="text-base text-white/70">
          Your exclusive workspace awaits.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 mt-2">
        <MenuCard
          title="方案諮詢"
          subtitle="Plan Consultation"
          path="https://lin.ee/jAeRoXE" // Original: "/consultation"
        />
        <MenuCard
          title="預約參觀"
          subtitle="Book a Tour"
          path="https://lin.ee/jAeRoXE" // Original: "/tour"
        />
        <MenuCard
          title="預約會議室"
          subtitle="Book a Meeting Room"
          path="/meeting-room"
          highlight={true}
        />
      </div>

      <div className="mt-4 px-0 py-2">
        <div className="relative overflow-hidden rounded-lg border border-white/10 bg-white/5 p-6 backdrop-blur-sm">
          <div className="absolute -right-12 -top-12 h-24 w-24 rounded-full bg-primary/10 blur-xl"></div>
          <div className="absolute -bottom-16 -left-12 h-32 w-32 rounded-full bg-primary/5 blur-2xl"></div>

          <h3 className="relative text-xl font-bold text-white">
            VIP 服務網頁升級中
          </h3>
          <p className="relative mt-2 text-sm text-white/70 leading-relaxed">
            我們正在打造全新的 VIP 專屬體驗，敬請期待。
          </p>
        </div>
      </div>

      <div className="flex flex-col items-center gap-4 py-6 mt-auto">
        <p className="text-sm text-white/60">
          Already a member?{' '}
          <button
            onClick={() => alert('系統升級中，目前無法登入')}
            className="font-bold text-primary underline decoration-primary/50 underline-offset-4 hover:text-primary/80 bg-transparent border-0 p-0 cursor-pointer"
          >
            Log in
          </button>
        </p>
      </div>
    </>
  );
};

export default Home;